import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseMaintenanceFinancialReviewSimpleEntriesApproveProps {
  financialReviewEntryId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceFinancialReviewSimpleEntriesApprove = ({
  financialReviewEntryId,
  options,
}: UseMaintenanceFinancialReviewSimpleEntriesApproveProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceFinancialReviewSimpleEntriesApprove'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/financial_review/simple_entries/${financialReviewEntryId}/approve`)
    },
    ...options,
  })
}
